import { render, staticRenderFns } from "./FinancialDashboard.vue?vue&type=template&id=e64c70e2&"
import script from "./FinancialDashboard.vue?vue&type=script&lang=js&"
export * from "./FinancialDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FinancialDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports